module.exports = __webpack_public_path__ + "img/cc.986d2e64.png";